export const getSelectedMembership = (state) => {
  return state.selectedMembership
}

export const getSelectedMembershipVariants = (state) => {
  return state.selectedMembership.variants
}
